import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';

import { camelCaseTransformer } from '@sondermind/utilities/tools';
import {
  IClientTestimonial,
  ITopTestimonial
} from '../models/client-testimonial.interface';

@Injectable({
  providedIn: 'root'
})
export class ClientTestimonialHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getTestimonialsForProvider(
    personaProviderId: number,
    apiOpts: Partial<IAPIListRequestOptions> = {}
  ): Observable<IClientTestimonial[] | null> {
    const url = `${this.configurationService.env.svcBase}/provider_profiles/${personaProviderId}/testimonials`;
    const params = this.http.generateListParams(apiOpts);

    return this.http
      .get<IAPIListResponse<IClientTestimonial>>(url, params)
      .pipe(
        map(({ data }) => camelCaseTransformer<IClientTestimonial[]>(data)),
        this.http.handleHttpError()
      );
  }

  getTopTestimonials(): Observable<ITopTestimonial[] | null> {
    const url = `${this.configurationService.env.svcBase}/referrals/providers/testimonials`;

    const filters: Partial<IAPIListRequestOptions> = {
      filterArray: [
        { key: 'exclude_aasm_states', value: 'timed_out' },
        { key: 'exclude_aasm_states', value: 'expired' }
      ]
    };

    const params = this.http.generateListParams(filters);

    return this.http
      .get<IAPIListResponse<ITopTestimonial>>(url, params)
      .pipe(
        map(({ data }) => camelCaseTransformer<ITopTestimonial[]>(data)),
        this.http.handleHttpError()
      );
  }
}
